import options from './folder-path-edit.directive';

export default {
    selector: 'dtFolderPathEdit',
    options
};



// WEBPACK FOOTER //
// ./app/common/folder-path-edit/index.js